import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Chip } from "@mui/material";
import Swal from "sweetalert2";
import { useParent } from "../../../../../APIContext/ParentContext";
import "./index.css";
import { useNavigate } from "react-router-dom";

const MySessions = () => {
  const navigate = useNavigate();
  const { fetchMySessions, checkBookingCancelStatus, cancelBooking } =
    useParent();
  const [sessionUPData, setSessionUPData] = useState([]);
  const [sessionCOMData, setSessionCOMData] = useState([]);
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchMySessions();
      if (result) {
        setSessionUPData(result.upcoming);
        setSessionCOMData(result.completed);
      } else {
        // Swal.fire({
        //   icon: "error",
        //   title: "Error",
        //   text: "Failed to fetch packages.",
        //   confirmButtonColor: "#f7931a",
        //   cancelButtonColor: "#1C1C1C",
        // });
        navigate("/login");
      }
    };

    fetchData();
  }, [refresh]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "-";

    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  function getLocalDate(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleDateString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  function getLocalTime(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  // const handleCancel = async (sale_id) => {
  //   const result = await Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you really want to cancel this subscription?",
  //     icon: "warning",
  //     showCancelButton: true,
  // confirmButtonColor: "#f7931a",
  // cancelButtonColor: "#1C1C1C",
  //     confirmButtonText: "Yes, Cancel it!",
  //     cancelButtonText: "No",
  //   });

  //   if (!result.isConfirmed) return;

  //   const formData = new FormData();
  //   formData.append("sale_id", sale_id);

  //   // const response = await cancelSubscription(formData);
  //   // if (response?.success) setRefresh(prev => !prev);
  // };

  const handleCancelSession = async (sessionId) => {
    try {
      const result = await checkBookingCancelStatus(sessionId);

      if (!result) return;

      const mainMessage = result.is_late_cancel
        ? `Late cancellation — a fee will be charged.`
        : `Are you sure you want to cancel this session?`;

      const swalResult = await Swal.fire({
        title: `Cancel Session`,
        html: `
        <p>${mainMessage}</p>
        <p><strong>Cancellation Fee:</strong> $${result.cancellation_fee}</p>
        <p>${result.message}</p>
      `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed To Cancel",
        cancelButtonText: "Keep Session",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-confirm-btn",
          cancelButton: "swal-cancel-btn",
        },
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      if (swalResult.isConfirmed) {
        await cancelBooking(
          sessionId,
          result.is_late_cancel,
          result.cancellation_fee,
        );
        const updatedData = await fetchMySessions();
        if (updatedData) {
          setSessionUPData(updatedData?.upcoming || []);
          setSessionCOMData(updatedData?.completed || []);
        }
      } else {
        console.log("User canceled the cancellation popup");
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while checking cancel status.",
      });
    }
  };

  return (
    <>
      <div
        style={{ filter: "brightness(1.28)" }}
        className="profile-content-area bg-custom"
      >
        <div className="profile-detail-container">
          <div className="player-header">
            <h2 className="text-clip">My Session (Upcoming)</h2>
          </div>
          <div className="package-table">
            <div style={{ filter: "brightness(1)" }} className="table-header">
              <span className="text-clip">Package Name</span>
              <span className="text-clip">Player Name</span>
              <span className="text-clip">Type</span>
              <span className="text-clip">Date</span>
              <span className="text-clip">Time</span>
              <span className="text-clip">Action</span>
            </div>

            {sessionUPData.length > 0 ? (
              sessionUPData.map((item, index) => {
                const isBooked = item.status === "booked";
                const isLateCancelled = item.status === "late_cancelled";
                const isCancelled = item.status === "cancelled";

                return (
                  <div
                    style={{ filter: "brightness(1)" }}
                    className="table-row bg-custom"
                    key={index}
                  >
                    <span className="text-clip" data-label="Package Name">
                      {item.package?.name || "-"}
                    </span>

                    <span className="text-clip" data-label="Player Name">
                      {item.player?.name || "-"}
                    </span>

                    <span className="text-clip" data-label="Type">
                      {item.sub_event?.is_one_on_one === true
                        ? "1 on 1"
                        : "Group" || "-"}
                    </span>

                    <span className="text-clip" data-label="Date">
                      {getLocalDate(item.sub_event?.start_datetime_utc) || "-"}
                    </span>

                    <span className="text-clip" data-label="Time">
                      {`${getLocalTime(item.sub_event?.start_datetime_utc)} - ${getLocalTime(item.sub_event?.end_datetime_utc)}` ||
                        "-"}
                    </span>

                    {isBooked ? (
                      <button
                        data-label="Action"
                        className="cancel-btn"
                        onClick={() => handleCancelSession(item?.id)}
                        style={{ background: "red", color: "#fff" }}
                      >
                        Cancel The Session
                      </button>
                    ) : (
                      <span className="session-status" data-label="Action">
                        {isLateCancelled
                          ? "Session Late Cancelled"
                          : "Session Cancelled"}
                      </span>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="no-package text-clip">
                No Upcoming Sessions Available
              </div>
            )}
          </div>

          <div className="player-header" style={{ marginTop: "20px" }}>
            <h2 className="text-clip">My Session (Completed)</h2>
          </div>
          <div className="package-table">
            <div style={{ filter: "brightness(1)" }} className="table-header">
              <span className="text-clip">Package Name</span>
              <span className="text-clip">Player Name</span>
              <span className="text-clip">Type</span>
              <span className="text-clip">Date</span>
              <span className="text-clip">Time</span>
              <span className="text-clip">Action</span>
            </div>

            {sessionCOMData.length > 0 ? (
              sessionCOMData.map((item, index) => (
                <div
                  style={{ filter: "brightness(1)" }}
                  className="table-row bg-custom"
                  key={index}
                >
                  <span className="text-clip" data-label="Package Name">
                    {item.package?.name || "-"}
                  </span>

                  <span className="text-clip" data-label="Player Name">
                    {item.player?.name}
                  </span>
                  <span className="text-clip" data-label="Type">
                    {item.sub_event?.is_one_on_one === true
                      ? "1 on 1"
                      : "Group" || "-"}
                  </span>
                  <span className="text-clip" data-label="Date">
                    {getLocalDate(item.sub_event?.start_datetime_utc) || "-"}
                  </span>

                  <span className="text-clip" data-label="Time">
                    {`${getLocalTime(item.sub_event?.start_datetime_utc)} - ${getLocalTime(item.sub_event?.end_datetime_utc)}` ||
                      "-"}
                  </span>
                  <span className="text-clip" data-label="Action">
                    Completed
                  </span>
                </div>
              ))
            ) : (
              <div className="no-package text-clip">
                No Completed Sessions Available
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MySessions;
